import styles from './Logo.module.css';

interface LogoProps {
  /** На тёмном фоне: шапка приложения, футер, CTA-полоса. */
  inverse?: boolean;
  title?: string;
}

/**
 * Словесный логотип. Часть «ViQ» набрана красным `--color-cta` — тем же,
 * что главное действие (референсы `main_screen`, `screen3`–`screen5`,
 * `2026-10/`).
 */
export function Logo({ inverse = false, title = 'CarViQ.DE' }: LogoProps) {
  return (
    <span className={[styles.logo, inverse && styles.inverse].filter(Boolean).join(' ')}>
      <span aria-hidden="true">Car</span>
      <span aria-hidden="true" className={styles.accent}>
        ViQ
      </span>
      <span aria-hidden="true">.DE</span>
      <span className="visually-hidden">{title}</span>
    </span>
  );
}
